import {sumBy, groupBy} from "lodash-es"
import BookingPriceBreakdown from '../defaultFlow/bookingPriceBreakdown.js'

export default class BookingPriceBreakdownDayTour extends BookingPriceBreakdown {
  constructor (options) {
    super(options)
  }

  prepareRoomsPrices () {
    const groups = groupBy(this.getRooms(), 'roomType')
    const allPassengers = this.getPassengers()
    const promisedFlightsPricePerPassenger = this.getPromisedFlightsPrice() / allPassengers.length

    return Object.entries(groups).map(([, rooms]) => {
      const passengers = rooms.flatMap(room => room.passengers)
      const basePrice = sumBy(passengers, (passenger) => passenger.price.base)
      const includedProductsPrice = this.showMiscellaneousProductBreakdown() ? 0 : sumBy(passengers, (passenger) => sumBy(passenger.price.included, 'price'))
      const promisedFlightsPrice = this.arePromisedFlightsBundled() ? promisedFlightsPricePerPassenger * passengers.length : 0

      return {
        name: `Day Tour`,
        price: basePrice + includedProductsPrice + promisedFlightsPrice,
        isDiscount: false,
      }
    })
  }
}